<template>
    <!-- ========== FAVORITE ROOMS ========== -->
    <section class="white_bg" id="rooms">
        <div class="container">
            <div class="main_title mt_wave a_center" v-if="title!=null">
                <h2>{{ title[currentLanguage] }}</h2>
            </div>
            <p class="main_description a_center" v-if="header!=null">
                {{ header[currentLanguage] }}
            </p>
            <div class="row">
                <favorite-room v-for="room in favorites" :key="room.id" :room="room"></favorite-room>
            </div>
            <div class="mt40 a_center" v-if="rooms.length > favorites.length">
                <router-link class="button btn_sm btn_yellow uppercase" to="/site/rooms" v-lang.view_room_list></router-link>
            </div>
        </div>
    </section>
</template>

<script>
    import favoriteRoom from '../favoriteRoom/favoriteRoom.vue';
    export default
    {
        components : {
            'favorite-room' : favoriteRoom,
        },
        data : function(){
            return {
                title : null,
                header : null,
                description : null,
                rooms : []
            };
        },
        computed : {
            favorites : function(){
                let list = _.filter( this.rooms, function(item)
                {
                    return item.favorite;
                });
                return list.length > 3 ?  list.slice(0,3) : list;
            },
            currentLanguage : function(){
                return this.$language;
            }
        },
        created : function(){
            let self = this;
            this.unsubscribe  = this.$store.subscribe((mutation,state) => {
                self.$language = self.$store.state.language;
                if( self.$store.getters.config!=null )
                {
                    self.header = self.$store.getters.config.rooms.header;
                    self.title = self.$store.getters.config.rooms.title;
                    self.rooms = self.$store.getters.config.rooms.items;
                    self.description = self.$store.getters.config.rooms.description || null;
                }
            });
            this.$store.watch( (state)=> {return this.$store.getters.config; }, (val) => {
                self.title = self.$store.getters.config.rooms.title;
                self.header = self.$store.getters.config.rooms.header;
                self.rooms = self.$store.getters.config.rooms.items;
                self.description = self.$store.getters.config.rooms.description || null;
            });
        },
        beforeDestroy : function(){
            this.unsubscribe();
        }
    }
</script>


// WEBPACK FOOTER //
// favoriteRooms.vue?d16f5ac4